import { ReactNode } from 'react';
import { getRangeForMonth } from '@/domain/termine/shared/utils/dateCalculations';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { useParams } from 'react-router-dom';
import { YearMonthParams } from '@/domain/termine/type';
import { CalendarContext } from './CalendarContext';
import { useTagesDaten } from '@/domain/termine/hooks/useTagesDaten';

interface CalendarProviderProps {
  children: ReactNode;
}

export function CalendarProvider({ children }: CalendarProviderProps) {
  const { year, month } = useParams<YearMonthParams>();
  const monthDate = {
    year: year ?? `${new Date().getFullYear()}`,
    month: month ?? `${new Date().getMonth() + 1}`,
  };
  const { startDate, endDate } = getRangeForMonth(monthDate);

  const {
    currentStandort: { id: standortId },
  } = useStandortContext();

  const zeitraum = {
    von: startDate.format('YYYY-MM-DD'),
    bis: endDate.format('YYYY-MM-DD'),
  };

  const { termine, feiertage } = useTagesDaten(
    standortId ? [standortId] : [],
    zeitraum,
  );

  return (
    <CalendarContext.Provider
      value={{
        monthDate,
        startDate,
        endDate,
        standortId,
        termine,
        feiertage,
      }}>
      {children}
    </CalendarContext.Provider>
  );
}
